import { useEffect, useState } from "react";

import {
  analytics, auth,
} from "../firebase/firebase-config";

export const useAuthListener = () => {

  const [loggedIn, setLoggedIn] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        analytics.setUserId(user.uid);
        setLoggedIn(true);
      }
      setCheckingStatus(false);
    });
  }, []);

  return { loggedIn, checkingStatus };
};